<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$route.meta.title"  :show_button="false" ></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="content_card_content" v-if="!loading">


<template v-if="!data.length">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz hiç kayıt oluşturulmamış</h3>

</div>
</template>

<template v-else>
<ContentTable :data="data" :columns="columns" routename="SupplierProjectDetail"  @dataDeleted="getData" identifier_row="uuid" identifier_row_name="project_id"></ContentTable>
</template>


</div>





</div>







</div>
</template>

<script>
export default {

  name: 'Evaluations',

  data () {
     return {
      data:[],
      loading:true,
      columns:[  
      {
        type:"text",
        field:"project_name",        
        with_route:true,
        header:"Proje",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"activeflow_name",
        header:"Aktif Akış",
        hide_on_mobile:false,
      },
      {
        type:"pill",
        field:"activeflowstatus",
        header:"Durum",
        options:[
          {
            name:"created",
            color:"#352f8d",
            text:"Oluşturuldu",
          },
          {
            name:"viewed",
            color:"#7e2f8d",
            text:"Görüntülendi",
          },
          {
            name:"started",
            color:"#dd4b39",
            text:"Başlandı",
          },
          {
            name:"finished",
            color:"#4dc247",
            text:"Tamamlandı",
          },
          {
            name:"under_review",
            color:"#ff6600",
            text:"Değelendirmede",
          },
          {
            name:"canceled",
            color:"#a82400",
            text:"İptal Edildi",
          },
        ],
      },      
      {
        type:"text",
        field:"supplier_name",
        header:"İşletme",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"brand_name",
        header:"Marka",
        hide_on_mobile:false,
      },
      ]
    }
  },
   mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
      this.loading = await true
  		let data = await this.generalApiGet("audits") 
      console.log(data);
      for(let item of data)
      {
        item.brand_name = item.project.brand.name
        item.project_name = item.project.name
        item.activeflow_name = item.activeflow.name
        if( item.activeflow.suppliers.length)
        {
          item.activeflowstatus = item.activeflow.suppliers[0].status
        }
        else
        {
          item.activeflowstatus = 0
        }
        
        item.supplier_name = item.supplier.name
        item.uuid = item.uuid
      }
      this.data = await data
      this.loading = await false
      console.log(this.data);
  	},
  	
  }
};
</script>

<style lang="css" scoped>
</style>